import React from 'react';
import PROXI_BRAIN_LOGO from '@/ui/assets/images/proxivideobrainlogo.png';
import { LightModal, LightMark } from '../light-ui';

interface GlobalLinkConfirmationModalProps {
  open: boolean;
  onContinue: () => void;
  onLogout: () => void;
  onSignIn?: () => void;
  userEmail?: string;
  proxiCastName?: string;
  adminName?: string;
  showSignInOption?: boolean;
}

const GlobalLinkConfirmationModal: React.FC<GlobalLinkConfirmationModalProps> = ({
  open,
  onContinue,
  onLogout,
  onSignIn,
  userEmail,
  proxiCastName = 'ProxiCast',
  adminName = 'Admin',
  showSignInOption = false,
}) => {
  const isSignedIn = !!userEmail;

  return (
    <LightModal open={open} dismissable={false} ariaLabel="Confirm interview participation">
      <div className="lp-modal-body" style={{ textAlign: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 18 }}>
          <LightMark src={PROXI_BRAIN_LOGO} size={64} />

          {isSignedIn ? (
            <>
              <span className="lp-frost-chip">Continue as</span>
              <h2 className="lp-section-heading" style={{ wordBreak: 'break-word', padding: '0 8px' }}>
                {userEmail}?
              </h2>
              <p className="lp-prose" style={{ maxWidth: 420 }}>
                You're already signed in. Would you like to participate in{' '}
                <span style={{ color: 'var(--lp-ink)' }}>
                  {adminName}'s {proxiCastName}
                </span>{' '}
                interview with your current account?
              </p>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 10, marginTop: 8 }}>
                <button type="button" onClick={onContinue} className="lp-btn lp-btn-primary">
                  Continue as {userEmail.split('@')[0]}
                </button>
                <button type="button" onClick={onLogout} className="lp-btn lp-btn-ghost">
                  Sign out & use different account
                </button>
              </div>
            </>
          ) : (
            <>
              <span className="lp-frost-chip">{proxiCastName}</span>
              <h2 className="lp-section-heading">You're invited.</h2>
              <p className="lp-prose" style={{ maxWidth: 420 }}>
                You're invited to participate in{' '}
                <span style={{ color: 'var(--lp-ink)' }}>
                  {adminName}'s {proxiCastName}
                </span>
                . Sign in to continue or create a new account.
              </p>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 10, marginTop: 8 }}>
                {showSignInOption && onSignIn && (
                  <button type="button" onClick={onSignIn} className="lp-btn lp-btn-primary">
                    Sign in
                  </button>
                )}
                <button type="button" onClick={onContinue} className="lp-btn">
                  Create new account
                </button>
              </div>
            </>
          )}

          <p style={{
            marginTop: 16,
            fontFamily: 'var(--lp-mono)',
            fontSize: 10,
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
            color: 'var(--lp-ink-mute)',
          }}>
            Powered by Proxi AI Studio
          </p>
        </div>
      </div>
    </LightModal>
  );
};

export default GlobalLinkConfirmationModal;
